// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { AccrualCepDto, ResultDto } from '@ideapa/common-dto';
import { SelectItem } from '@ideapa/common-interfaces';
import { map, Observable } from 'rxjs';
import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class AccrualCepApiClient extends BaseCRUDApiClient<AccrualCepDto> {
  baseUrl = this.config.apiEndpoint + '/accrual-cep';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getTassonomie() {
    return this.http.get<SelectItem[]>(`${this.baseUrl}/tassonomie`);
  }

  importAccrualFile(file: File) {
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<ResultDto>(this.baseUrl + '/import-accrual', fd);
  }

  downloadAccrualFile(): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-accrual',
        {},
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  downloadBdap(tassonomia: string, fileName: string): Observable<ArrayBuffer> {
    // console.log('tassonomia: ', tassonomia);
    // console.log('fileName: ', fileName);
    return this.http
      .post(
        this.baseUrl + '/download-bdap',
        {
          tassonomia: tassonomia,
          fileName: fileName,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }
}
